<template>
  <div>
    <!-- !PAGE CONTENT! -->
    <div class="w3-main" style="margin-left:300px;margin-right:40px;" id="home">
      <NoticeDisplay />
      <!-- Hero image -->
      <div
        class="fill"
        style="margin-left:0px;margin-right:0px; width:100vw; height:100vh"
      >
        <h1 class="w3-xxlarge w3-text-white welcome-margin">
          <b>Welcome.</b>
        </h1>
        <h2 class="w3-xlarge w3-text-white" style="margin-left:10vw">
          <b>- Global Data Information Systems Pvt. Ltd.</b>
        </h2>
      </div>
      <!-- About us -->
      <div class="w3-content w3-container containerdiv" id="aboutus">
        <div class="w3-hide-large" style="margin-top:80px"></div>
        <h1 class="w3-xxlarge w3-text-black">
          <b>About Us.</b>
        </h1>
        <hr style="width:50px;border:5px solid black" class="w3-round" />
        <p>
          GDIS (Global Data Information Systems) Pvt. Ltd. is a sole financial
          data provider which was established in 1998 and is based in Kathmandu,
          Nepal. It is an esteemed company providing reliable market data to
          financial firms, traders and investors since past 22 years. The data
          distributed is collected from several sources such as stock exchange
          feeds, brokers and dealer desks or SEC filings and finally recorded
          into our portal.
        </p>
      </div>
      <!-- Services -->
      <div
        class="w3-container containerdiv"
        id="services"
        style="margin-top:75px"
      >
        <div class="w3-hide-large" style="margin-top:80px"></div>
        <h1 class="w3-xxlarge w3-text-black">
          <b>Services.</b>
        </h1>
        <hr style="width:50px;border:5px solid black" class="w3-round" />
        <p>
          The data offered by GDIS typically covers information about entities
          (companies). The type of data that our company sells can be divided
          broadly into following categories:
        </p>
        <p>
          1) Pricing data (prices of company stocks and their movements)
        </p>
        <p>
          2) Corporate actions and events.
        </p>
        <p>
          3) Value added data such as listing information, share data,
          fundamental data, merger &amp; acquisition data, dividend data,
          historical data etc.
        </p>
      </div>
      <!-- Mission -->
      <div
        class="w3-container containerdiv"
        id="mission"
        style="margin-top:75px"
      >
        <div class="w3-hide-large" style="margin-top:80px"></div>
        <h1 class="w3-xxlarge w3-text-black">
          <b>Mission.</b>
        </h1>
        <hr style="width:50px;border:5px solid black" class="w3-round" />
        <p>
          Data is foundation of research and our mission is to provide reliable
          data timely to help companies’ to power new generation of innovation
          in field of financial research world.
        </p>
      </div>
      <!-- Vision -->
      <div
        class="w3-container containerdiv"
        id="vision"
        style="margin-top:75px"
      >
        <div class="w3-hide-large" style="margin-top:80px"></div>
        <h1 class="w3-xxlarge w3-text-black">
          <b>Vision.</b>
        </h1>
        <hr style="width:50px;border:5px solid black" class="w3-round" />
        <p>
          We envision a future where we have the historical data that helps
          create insights and, innovators in turn will be able to leverage those
          insights to lead a brand new future for the financial industry.
        </p>
      </div>
      <!-- SharePrice -->
      <Shareprice />

      <!-- Indices -->
      <Indices />

      <!-- Agms -->
      <Agms />

      <!-- Dividends -->
      <Dividends />

      <!-- Rightshares -->
      <Rightshares />

      <!-- Packages / Pricing Tables -->
      <!-- <div class="w3-container" id="packages" style="margin-top:75px">
      <h1 class="w3-xxxlarge w3-text-black">
        <b>Packages.</b>
      </h1>
      <hr style="width:50px;border:5px solid black" class="w3-round" />
      <p>
        Some text our prices. Lorem ipsum consectetur adipiscing elit, sed do
        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
        minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip
        ex ea commodo consequat. Duis aute irure
      </p>
    </div>

    <div class="w3-row-padding">
      <div class="w3-half w3-margin-bottom">
        <ul class="w3-ul w3-light-grey w3-center">
          <li class="w3-dark-grey w3-xlarge w3-padding-32">Basic</li>
          <li class="w3-padding-16">Floorplanning</li>
          <li class="w3-padding-16">10 hours support</li>
          <li class="w3-padding-16">Photography</li>
          <li class="w3-padding-16">20% furniture discount</li>
          <li class="w3-padding-16">Good deals</li>
          <li class="w3-padding-16">
            <h2>$ 199</h2>
            <span class="w3-opacity">per room</span>
          </li>
          <li class="w3-light-grey w3-padding-24">
            <button class="w3-button w3-white w3-padding-large w3-hover-black">Sign Up</button>
          </li>
        </ul>
      </div>

      <div class="w3-half">
        <ul class="w3-ul w3-light-grey w3-center">
          <li class="w3-black w3-xlarge w3-padding-32">Pro</li>
          <li class="w3-padding-16">Floorplanning</li>
          <li class="w3-padding-16">50 hours support</li>
          <li class="w3-padding-16">Photography</li>
          <li class="w3-padding-16">50% furniture discount</li>
          <li class="w3-padding-16">GREAT deals</li>
          <li class="w3-padding-16">
            <h2>$ 249</h2>
            <span class="w3-opacity">per room</span>
          </li>
          <li class="w3-light-grey w3-padding-24">
            <button class="w3-button w3-black w3-padding-large w3-hover-black">Sign Up</button>
          </li>
        </ul>
      </div>
      </div>-->

      <!-- Contact -->
      <div class="w3-container containerdiv" id="contact">
        <div class="w3-hide-large" style="margin-top:80px"></div>
        <h1 class="w3-xxlarge w3-text-black">
          <b>Contact.</b>
        </h1>
        <hr style="width:50px;border:5px solid black" class="w3-round" />
        <p>GDIS (Global Data Information Systems) Pvt. Ltd.</p>
        <p>Kathmandu, Nepal</p>
        <p>Phone:</p>
        <p>email:</p>
      </div>

      <!-- End page content -->
    </div>
  </div>
</template>

<script>
import Shareprice from "@/components/Shareprice";
import Indices from "@/components/Indices";
import Agms from "@/components/Agms";
import Dividends from "@/components/Dividends";
import Rightshares from "@/components/Rightshares";
import NoticeDisplay from "@/components/noticeDisplay";
export default {
  name: "Home",
  components: {
    Shareprice,
    Indices,
    Agms,
    Dividends,
    Rightshares,
    NoticeDisplay,
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style scoped>
.fill {
  overflow: hidden;
  background-size: cover;
  background-position: center;
  /* background-color: brown; */
  background-image: url("../assets/hero.jpg");
}
.welcome-margin {
  margin-top: 25vh;
  margin-left: 10vw;
}
</style>
